<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {computed, ref} from "vue";
import {type AlertVariants, alertVariants} from '.'
import {cn} from '@/shared/lib/utils'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faCheckCircle, faInfoCircle, faTriangleExclamation, faXmarkCircle, faTimes} from "@fortawesome/pro-solid-svg-icons";

const props = withDefaults(defineProps<{
  class?: HTMLAttributes['class']
  variant?: AlertVariants['variant']
  dismissible?: boolean
}>(), {
  dismissible: false
})

const icon = computed(() => findIcon(props.variant))

function findIcon(variant?: string | null) {
  switch (variant) {
    case 'informative':
      return {icon: faInfoCircle, color: 'text-blue-500'}
    case 'postive':
      return {icon: faCheckCircle, color: 'text-green-500'}
    case 'notice':
      return {icon: faTriangleExclamation, color: 'text-yellow-500'}
    case 'negative':
      return {icon: faXmarkCircle, color: 'text-red-500'}
    default:
      return {icon: faInfoCircle, color: 'text-slate-950'}
  }
}

const visible = ref(true)

</script>

<template>
  <div :class="cn(alertVariants({ variant }), props.class)" role="alert" class="relative" v-if="visible">
    <div v-if="dismissible" class="absolute right-default top-default" @click="visible = false"> <FontAwesomeIcon :icon="faTimes" /></div>
    <div class="flex">
      <div class="flex-shrink-0">
        <FontAwesomeIcon :icon="icon.icon" :class="icon.color"/>
      </div>
      <div class="ml-3 w-full">
        <slot/>
      </div>
    </div>
  </div>
</template>
